import { Form } from 'antd'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'

import { TagDescription } from '../../constants/forms/CustomerTags'
import { CreateCustomerTag as request } from '../../network/CustomerTags'

const CreateCustomerTag = () => {
    const [form] = Form.useForm()

    return (
        <PageWrap goBack title="CUSTOMER_TAGS_CREATE_TAG">
            <FormWrap
                title="create_customer_tag"
                request={request}
                onSuccess={'/customer-tags'}
                onCancel={'/customer-tags'}
                invalidate={['getCustomerTags']}
            >
                <div className="SectionVerticalWrap">
                    <FormBlock form={form} formTemplate={TagDescription} />
                </div>
            </FormWrap>
        </PageWrap>
    )
}

export default CreateCustomerTag
